import { render, staticRenderFns } from "./DashboardSchool.vue?vue&type=template&id=287d9f0c&scoped=true&"
import script from "./DashboardSchool.vue?vue&type=script&lang=js&"
export * from "./DashboardSchool.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSchool.vue?vue&type=style&index=0&id=287d9f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d9f0c",
  null
  
)

export default component.exports